module.exports = __webpack_public_path__ + "static/media/space_cloud.305b7b7b.svg";